// Methods Imports
import {
  isApprovalRequired,
  isDocRenameRequired,
  isEsignLimitExceeded,
  showDocStatusUpdate,
  showEsignWarning,
  showUnfilledFormFieldWarning,
  showDocFillerStatusUpdate,
} from "../Methods/eSignMethod";

const E_SIGN_FLOW = [
  {
    name: "E-Sign Limit Increase",
    description: "Check if the user has reached his esign usage limit",
    method: isEsignLimitExceeded,
  },
  {
    name: "Document Rename",
    description:
      "If doc name is titled as 'Untitled Document', then show a popup to rename the document",
    method: isDocRenameRequired,
  },
  {
    name: "E-Sign Warning",
    description:
      "If esign block not added or required esign data filled, then show warning msg",
    method: showEsignWarning,
  },
  {
    name: "Unfilled Form Fields Warning",
    description:
      "If its a form type document and when all the fields are not filled, then show this popup to either go back or continue anyway to trigger esign",
    method: showUnfilledFormFieldWarning,
  },
  {
    name: "Approval Check",
    description:
      "In this 2 cases are handled, if any workflow is attached to the doc wrt to dealtable, clause or dynamic field, then approval else esign flow get triggered",
    method: isApprovalRequired,
  },
  {
    name: "Document Status Update",
    description: "Show an option for the user to update the document status",
    method: showDocStatusUpdate,
  },
  {
    name: "Document Status Update For Esign Filler",
    description: "Congratulation popup for doc which sent for esign filler ",
    method: showDocFillerStatusUpdate,
  },
  {
    name: "E-Sign Limit Increase",
    description: "Check if the user has reached his esign usage limit",
    method: isEsignLimitExceeded,
  },
];

export default E_SIGN_FLOW;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Configuration/eSignConfig.js